export default {"src":"/_next/static/media/cxVal2.dc4a091d.svg","height":155,"width":67,"blurWidth":0,"blurHeight":0};